"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74715],{

/***/ 560327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getBanners; },
/* harmony export */   "Q": function() { return /* binding */ BannerInlinePlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _constants_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(346115);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167520);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(901550);
/* harmony import */ var _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(603651);






const filterHeightInlineInRootNode = (banners, isMobile) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  let sizePopups = [];
  for (let obj of banners) {
    let content = obj.content;
    for (let key in content) {
      if (content.hasOwnProperty(key)) {
        if (content[key].parentId === "ROOT" && content[key].tag === "inlinebanner" && ((_c = (_b = (_a = content[key]) == null ? void 0 : _a.customAttributes) == null ? void 0 : _b.inlinebanner) == null ? void 0 : _c.relativePosition) === _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .ERelativePosition.IN */ .zH.IN) {
          const isPopUpShowInDesktop = !((_g = (_f = (_e = (_d = content[key]) == null ? void 0 : _d.customAttributes) == null ? void 0 : _e.inlinebanner) == null ? void 0 : _f.responsive) == null ? void 0 : _g.hiddenMd);
          const isPopUpShowInMobile = !((_k = (_j = (_i = (_h = content[key]) == null ? void 0 : _h.customAttributes) == null ? void 0 : _i.inlinebanner) == null ? void 0 : _j.responsive) == null ? void 0 : _k.hiddenXs);
          if (isMobile && isPopUpShowInMobile || !isMobile && isPopUpShowInDesktop) {
            sizePopups.push({
              className: content[key].customAttributes.inlinebanner.cssSelector,
              height: (_l = content[key].style.height) != null ? _l : 0,
              width: (_m = content[key].style.width) != null ? _m : 0
            });
          }
        }
      }
    }
  }
  return sizePopups;
};
const getBanners = async ({
  cookies,
  configs,
  env,
  flagsup
}) => {
  const { appId, iamId, trackingAppId, url, isMobile } = configs;
  const parsedCookies = cookie__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Q(cookies);
  const isNewVisitor = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VP */ .CP] !== _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .UNIDENTIFIED */ .eF || parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VS */ .U6] === _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .NEW_USER */ .MB;
  const trackingId = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TRACKING_ID */ .tz];
  const isMa79Enabled = flagsup.epic_ma_79;
  const handleSubscribe = async () => {
    if (!appId)
      return;
    try {
      const discoveryService = new _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__/* .OnSiteDiscoveryService */ .T(env);
      const body = {
        appId,
        iamId,
        trackingAppId,
        onlyNewVisitor: isNewVisitor,
        url,
        trackingId: isMa79Enabled ? trackingId : void 0
      };
      const banners2 = await discoveryService.subscribeSmartPopup(body);
      return filterHeightInlineInRootNode(banners2, isMobile);
    } catch (e) {
      console.error(e);
    }
  };
  const banners = await handleSubscribe() || [];
  return banners;
};
const BannerInlinePlaceholder = ({
  banners = [],
  className
}) => {
  const matchBanners = banners == null ? void 0 : banners.filter(
    (banner) => banner.className === `.${className}`
  );
  const totalBannerHeight = matchBanners == null ? void 0 : matchBanners.reduce(
    (total, banner) => total + banner.height,
    0
  );
  const maxBannerWidth = matchBanners == null ? void 0 : matchBanners.reduce(
    (max, banner) => Math.max(max, banner.width),
    0
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: matchBanners ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className,
      style: {
        minHeight: `${totalBannerHeight}px`,
        width: `${maxBannerWidth}px`
      }
    }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className
    })
  });
};




/***/ }),

/***/ 346115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CP": function() { return /* binding */ TEMPI_VP; },
/* harmony export */   "GN": function() { return /* binding */ DEFAULT_LIMIT_TIME; },
/* harmony export */   "Hi": function() { return /* binding */ RETURNING; },
/* harmony export */   "J2": function() { return /* binding */ SMART_POPUP_CONFIG; },
/* harmony export */   "MB": function() { return /* binding */ NEW_USER; },
/* harmony export */   "SI": function() { return /* binding */ EXPIRE_MINUTE; },
/* harmony export */   "U6": function() { return /* binding */ TEMPI_VS; },
/* harmony export */   "eF": function() { return /* binding */ UNIDENTIFIED; },
/* harmony export */   "hR": function() { return /* binding */ DEFAULT_DISPLAY_VALUE; },
/* harmony export */   "to": function() { return /* binding */ VIEW_INTERVAL_DURATION; },
/* harmony export */   "tz": function() { return /* binding */ TRACKING_ID; }
/* harmony export */ });
const EXPIRE_MINUTE = 20;
const TEMPI_VP = "_tempi_vp";
const TEMPI_VS = "_tempi_vs";
const SMART_POPUP_CONFIG = "_smart_banner_config";
const NEW_USER = "NEW";
const RETURNING = "RETURNING";
const UNIDENTIFIED = "unidentified";
const VIEW_INTERVAL_DURATION = 100;
const DEFAULT_DISPLAY_VALUE = 1;
const DEFAULT_LIMIT_TIME = 1;
const TRACKING_ID = "_track__track";




/***/ }),

/***/ 603651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ OnSiteDiscoveryService; }
/* harmony export */ });
/* harmony import */ var _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(988966);


const onSiteDiscoveryUrl = {
  dev: "https://smart-activation-discovery.dev.tekoapis.net/api",
  stag: "https://smart-activation-discovery.stag.tekoapis.net/api",
  production: "https://smart-activation-discovery.tempi.vn/api"
};
class OnSiteDiscoveryService {
  constructor(env) {
    this.client = new _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__/* .Api */ .V(onSiteDiscoveryUrl[env]);
  }
  async subscribeSmartPopup(params) {
    var _a;
    const { data } = await this.client.post(
      "/v1/smart-activation/subscribe",
      params
    );
    return ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.popups) || [];
  }
}




/***/ }),

/***/ 901550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RW": function() { return /* binding */ ETimeUnit; },
/* harmony export */   "Wv": function() { return /* binding */ EBannerEvent; },
/* harmony export */   "zH": function() { return /* binding */ ERelativePosition; }
/* harmony export */ });
var EBannerEvent = /* @__PURE__ */ ((EBannerEvent2) => {
  EBannerEvent2[EBannerEvent2["DISPLAY"] = 0] = "DISPLAY";
  EBannerEvent2[EBannerEvent2["CLICK"] = 1] = "CLICK";
  EBannerEvent2[EBannerEvent2["CLOSE"] = 2] = "CLOSE";
  return EBannerEvent2;
})(EBannerEvent || {});
var ETimeUnit = /* @__PURE__ */ ((ETimeUnit2) => {
  ETimeUnit2[ETimeUnit2["MINUTE"] = 0] = "MINUTE";
  ETimeUnit2[ETimeUnit2["HOUR"] = 1] = "HOUR";
  ETimeUnit2[ETimeUnit2["SESSION"] = 1] = "SESSION";
  return ETimeUnit2;
})(ETimeUnit || {});
var ERelativePosition = /* @__PURE__ */ ((ERelativePosition2) => {
  ERelativePosition2["BEFORE"] = "before";
  ERelativePosition2["AFTER"] = "after";
  ERelativePosition2["IN"] = "in";
  return ERelativePosition2;
})(ERelativePosition || {});




/***/ }),

/***/ 380822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ s; }
/* harmony export */ });
class s{constructor(s,e,t){this.message=s,this.response=t,this.code=e}get reason(){return this.response}}


/***/ }),

/***/ 988966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83492);
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(opentracing__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _error_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(380822);
var s=Object.defineProperty,a=Object.defineProperties,n=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(t,e,r)=>e in t?s(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,h=(t,e)=>{for(var r in e||(e={}))i.call(e,r)&&p(t,r,e[r]);if(o)for(var r of o(e))c.call(e,r)&&p(t,r,e[r]);return t};const l=(t="",e)=>`${t.endsWith("/")?t.slice(0,t.length-1):t}/${e.startsWith("/")?e.slice(1):e}`;class u{constructor(t,e,r={}){this.baseURL=t,this.interceptors=[],this.getError=e,this.defaultConfig=r}_parseJson(t){return t.text().then((t=>t?JSON.parse(t):null))}addInterceptor(t){this.interceptors.push(t)}appendParamsToURL(t,e={}){if(e){const r=[];for(const t of Object.keys(e))null!==e[t]&&void 0!==e[t]&&r.push(`${t}=${encodeURIComponent(e[t])}`);r.length>0&&(t=`${t}?${r.join("&")}`)}return t}async request(s,o,i,c={}){var p;const{params:u}=c;let f=c.headers||{};const d=this.appendParamsToURL(s,u||{});let g=null;const y=o&&"string"!=typeof o&&"append"in o;o&&"string"!=typeof o&&(y?g=new URLSearchParams(o).toString():(g=JSON.stringify(o),f=h({"Content-Type":"application/json"},f)));let b=null;u&&(b=JSON.stringify(u));const m=(0,opentracing__WEBPACK_IMPORTED_MODULE_0__.globalTracer)(),w=`[${i}] ${l(this.baseURL,s)}`,O=m.startSpan(w);m.inject(O,opentracing__WEBPACK_IMPORTED_MODULE_0__.FORMAT_HTTP_HEADERS,f),O.setTag("http.method",i),O.setTag("http.baseurl",this.baseURL),O.log({body:g,params:b});const j=(P=h({},this.defaultConfig),T={method:i,headers:new Headers(f),body:y?o:g},a(P,n(T)));var P,T;this.interceptors.forEach((t=>t(j)));const E=await fetch(d.startsWith("http")?d:l(this.baseURL,d),j);if(E.status>=400){const t=await E.json(),e=(null==(p=this.getError)?void 0:p.call(this,t))||new _error_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ApiError */ .M("Đã có lỗi xảy ra, vui lòng thử lại sau!",-1,t);return O.setTag("status","error"),O.log({error:JSON.stringify(e)}),O.finish(),Promise.reject(e)}const v={};E.headers.forEach(((t,e)=>v[e]=t));const S=await this._parseJson(E);return O.setTag("status","success"),O.finish(),{code:E.status,data:S,headers:v}}async get(t,e={}){return await this.request(t,null,"GET",e)}async post(t,e,r={}){return await this.request(t,e,"POST",r)}async patch(t,e,r={}){return await this.request(t,e,"PATCH",r)}async put(t,e,r={}){return await this.request(t,e,"PUT",r)}async delete(t,e={},r={}){return await this.request(t,e,"DELETE",r)}}


/***/ }),

/***/ 106980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ canUseDom; }
/* harmony export */ });
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/***/ }),

/***/ 983947:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (KeyCode);

/***/ }),

/***/ 514796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ wrapperRaf; }
/* harmony export */ });
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};

var caf = function caf(num) {
  return clearTimeout(num);
};

if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };

  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}

var rafUUID = 0;
var rafIds = new Map();

function cleanup(id) {
  rafIds.delete(id);
}

function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;

  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id); // Trigger

      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      }); // Bind real raf id

      rafIds.set(id, realId);
    }
  }

  callRef(times);
  return id;
}

wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};

/***/ }),

/***/ 26515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mH": function() { return /* binding */ fillRef; },
/* harmony export */   "sQ": function() { return /* binding */ composeRef; }
/* harmony export */ });
/* unused harmony export supportRef */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12129);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(552744);


function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */

function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;

  var type = isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type; // Function component node

  if (typeof type === 'function' && !((_type$prototype = type.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }

  return true;
}
/* eslint-enable */

/***/ }),

/***/ 167520:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
__webpack_unused_export__ = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.partitioned) {
    str += '; Partitioned'
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ })

}]);